"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const createCandyGuard_1 = require("./createCandyGuard");
const createCandyMachineV2_1 = require("./createCandyMachineV2");
const generated_1 = require("./generated");
const hooked_1 = require("./hooked");
const create = async (context, input) => {
    const { guards, groups, ...rest } = input;
    const candyGuard = (0, hooked_1.findCandyGuardPda)(context, {
        base: input.candyMachine.publicKey,
    });
    return (0, umi_1.transactionBuilder)()
        .add(await (0, createCandyMachineV2_1.createCandyMachineV2)(context, rest))
        .add((0, createCandyGuard_1.createCandyGuard)(context, {
        base: input.candyMachine,
        guards,
        groups,
    }))
        .add((0, generated_1.wrap)(context, {
        candyGuard,
        candyMachine: input.candyMachine.publicKey,
    }));
};
exports.create = create;
//# sourceMappingURL=create.js.map